export default "__VITE_ASSET__7c71b5d3__"